import { hslToHex, hexToHSL } from './colorConversion'

export interface HSLColor {
  h: number
  s: number
  l: number
}

export const calculateAccentColor = (secondary: HSLColor, isDarkMode: boolean): HSLColor => {
  if (isDarkMode) {
    return {
      h: secondary.h,
      s: Math.max(0, Math.min(100, secondary.s - 8)),
      l: Math.max(0, Math.min(100, secondary.l - 12))
    }
  } else {
    return {
      h: secondary.h,
      s: Math.max(0, Math.min(100, secondary.s - 9)),
      l: Math.max(0, Math.min(100, secondary.l + 2))
    }
  }
}

export const getDefaultColors = (isDarkMode: boolean): { secondary: HSLColor; accent: HSLColor } => {
  const defaultSecondary = isDarkMode 
    ? { h: 35, s: 24, l: 47 }  // #8d7e62
    : { h: 35, s: 28, l: 53 }  // #9d8e72
    
  return {
    secondary: defaultSecondary,
    accent: calculateAccentColor(defaultSecondary, isDarkMode)
  }
}